import api from './axiosConfig';

const newsService = {
  /**
   * Gera uma nova notícia.
   * Modificado para aceitar 'type' (round/phase) e 'value' (número da rodada ou nome da fase).
   * Retorna: O objeto da resposta da API (ex: { success: true, message: "...", article: {...} }).
   */
  async generate(championshipId, type, value) {
    if (!type || !value) {
      throw new Error('Tipo (round/phase) e valor (número ou nome da fase) são obrigatórios.');
    }
    try {
      // Ex: /news/:championshipId/generate?type=round&value=1
      // Ex: /news/:championshipId/generate?type=phase&value=final
      const response = await api.post(`/news/${championshipId}/generate`, null, {
        params: { type, value }
      });
      return response.data;
    } catch (error) {
      console.error("Erro em newsService.generate:", error);
      throw error;
    }
  },

  /**
   * Lista todos os artigos para um admin (rascunhos e publicados).
   * Retorna: Um array de artigos.
   */
  async listAllForAdmin(championshipId) {
    try {
      const response = await api.get(`/news/${championshipId}/admin/all`);
      return response.data;
    } catch (error) {
      console.error("Erro em newsService.listAllForAdmin:", error);
      throw error;
    }
  },

  /**
   * Lista apenas os artigos publicados.
   * Retorna: Um array de artigos.
   */
  async listPublished(championshipId) {
    try {
      const response = await api.get(`/news/${championshipId}/articles`);
      return response.data;
    } catch (error) {
      console.error("Erro em newsService.listPublished:", error);
      throw error;
    }
  },

  /**
   * Publica um artigo.
   * Retorna: O objeto da resposta da API (ex: { message: "...", article: {...} }).
   */
  async publish(articleId) {
    try {
      const response = await api.patch(`/news/${articleId}/publish`);
      return response.data;
    } catch (error) {
      console.error("Erro em newsService.publish:", error);
      throw error;
    }
  },

  /**
   * Atualiza um artigo de notícia existente.
   * @param {string} articleId - O ID do artigo a ser atualizado.
   * @param {object} data - Objeto contendo { title, content }.
   * @returns {Promise<object>} O objeto da resposta da API.
   */
  async update(articleId, data) {
    try {
      const response = await api.put(`/news/${articleId}`, data);
      return response.data;
    } catch (error) {
      console.error("Erro em newsService.update:", error);
      throw error;
    }
  },

  /**
   * Exclui um artigo de notícia existente.
   * @param {string} articleId - O ID do artigo a ser excluído.
   * @returns {Promise<object>} O objeto da resposta da API.
   */
  async delete(articleId) {
    try {
      const response = await api.delete(`/news/${articleId}`);
      return response.data;
    } catch (error) {
      console.error("Erro em newsService.delete:", error);
      throw error;
    }
  },
};

export default newsService;